/**
 * Newsletter API client.
 *
 * Mirrors `POST /api/site-settings/subscribe` on the Hono API. Returns
 * a discriminated union so callers can react to the success / error
 * branches without try/catch.
 */

import type { ApiResponse } from '@abdallah-issa/shared'

const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')

export interface SubscribeInput {
  email: string
  name?: string
  /** Cloudflare Turnstile token. Required in production; optional locally. */
  turnstileToken?: string
}

interface SubscribeData {
  message: string
}

export type SubscribeResponse = ApiResponse<SubscribeData>

export async function subscribe(
  input: SubscribeInput,
): Promise<SubscribeResponse> {
  if (!API_URL) {
    return {
      success: false,
      error: {
        code: 'OFFLINE',
        message: 'الـ API غير متاح في وضع المعاينة',
      },
    }
  }
  try {
    const res = await fetch(`${API_URL}/site-settings/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(input),
    })
    const json = (await res.json()) as SubscribeResponse
    return json
  } catch (err) {
    return {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        message: 'تعذّر الاتصال بالخادم. تحقق من الإنترنت.',
        details: err instanceof Error ? err.message : String(err),
      },
    }
  }
}
